<template>
    <fragment v-if="lote.modoEdicao">
        <b-button-group class="d-flex w-100 wrapper-multiselect-sagres">
            <multiselect v-model="vencedorSelecionado" close-on-select searchable :show-labels="false"
                label="NmParticipante" deselect-label="" :allow-empty="true" placeholder="Selecione um"
                track-by="IdParticipanteLicitacao" :options="participantes" class="w-100" :disabled="isLoading">
                <template slot="noOptions">
                    <small><i>Nenhum participante cadastrado</i></small>
                </template>
                <template slot="noResult">
                    <i>Nenhum participante encontrado</i>
                </template>
            </multiselect>
            <b-button size="sm" @click="alterarParticipanteVencedorDoLote()" variant="success" :disabled="isLoading">
                <b-spinner v-if="isLoading" small class="align-middle"></b-spinner>
                <span v-else>ok</span>
            </b-button>
            <b-button size="sm" @click="cancelarAlteracao()" variant="danger" :disabled="isLoading" class="extra-small">
                <font-awesome-icon icon="ban" class="mr-1" />
            </b-button>
        </b-button-group>
    </fragment>
    <fragment v-else>
        <span v-if="lote.FlFracassado === 'Sim'">--</span>
        <fragment v-else>
            <span v-if="mostrarNomeParticipante">
                {{ lote.IdParticipanteLicitacaoNavigation.NmParticipante }}
            </span>
            <b-button size="sm" variant="outline-secondary" class="ml-1 extra-small"
                @click="escolherParticipanteVencedor()">
                <font-awesome-icon v-if="mostrarNomeParticipante" icon="refresh" />
                <fragment v-else>
                    <font-awesome-icon icon="trophy" class="mr-1" />
                    Escolher vencedor
                </fragment>
            </b-button>
        </fragment>
    </fragment>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import Multiselect from "vue-multiselect";

import ldiService from '@/services/licitacoes/ldiService'
import { LicitacaoVencedorLote } from '@/types/licitacoes/ldi/licitacao-vencedor-lote';
import { ParticipanteLicitacao } from '@/types/licitacoes/ldi/participante-licitacao';

const CompProps = Vue.extend({
    name: 'SeletorVencedorLote',
    components: { Multiselect },
    props: {
        lote: {
            type: Object,
            required: true
        },
        participantes: {
            type: Array,
            required: true
        }
    },
})

@Component
export default class SeletorVencedorLote extends CompProps {
    isLoading = false
    vencedorSelecionado: ParticipanteLicitacao | string = ''

    get mostrarNomeParticipante() {
        return this.lote.IdParticipanteLicitacaoNavigation && this.lote.IdParticipanteLicitacaoNavigation.NmParticipante
    }

    async escolherParticipanteVencedor(): Promise<void> {
        this.$emit('modoEdicao')
        if (!(this.vencedorSelecionado instanceof ParticipanteLicitacao) && this.lote.IdParticipanteLicitacaoNavigation !== null) {
            this.vencedorSelecionado = Object.assign(new ParticipanteLicitacao(), this.lote.IdParticipanteLicitacaoNavigation)
        }
    }

    async alterarParticipanteVencedorDoLote(): Promise<void> {
        try {
            if (this.vencedorSelecionado instanceof ParticipanteLicitacao) {
                this.isLoading = true
                const retorno = await ldiService.alterarVencedorLoteLicitacao(this.lote.IdLoteLicitacao, this.vencedorSelecionado.IdParticipanteLicitacao)
                const lvl = new LicitacaoVencedorLote()
                lvl.NmParticipante = retorno.IdParticipanteLicitacaoNavigation.NmParticipante
                lvl.participanteVencedor = retorno.IdParticipanteLicitacaoNavigation.IdParticipanteLicitacao
                lvl.IdParticipanteLicitacaoNavigation = Object.assign(new ParticipanteLicitacao(), retorno.IdParticipanteLicitacaoNavigation)
                lvl.modoEdicao = false
                lvl._rowVariant = ''
                lvl.loading = false
                this.$emit('vencedorFoiAlterado', lvl)
            } else {
                this.$toast.warning('Selecione o participante vencedor!')
            }
        } finally {
            this.isLoading = false
        }
    }

    cancelarAlteracao(): void {
        this.$emit('cancelarEdicao')
    }
}
</script>
<style scoped></style>